import { Empty } from "antd";

function PDFPage9Table2(props: any) {
    return (
        <>
            <table className="table table-sm table-bordered cu-table-border cu-fs-12">
                <thead className="cu-bg-green">
                    <tr>    
                        <th style={{width:"25%"}} className="fw-600">{props.TranslateString("Kunnossapitotarve")}</th>
                        <th style={{width:"25%"}} className="fw-600">{props.TranslateString("Toimenpiteen laajuus")} </th>
                        <th style={{width:"35%"}} className="fw-600">{props.TranslateString("Tarkka kuvaus")} </th>
                        <th style={{width:"15%"}} className="fw-600">{props.TranslateString("Aloitus")}</th>
                    </tr> 
                </thead>
                <tbody className="bg-light">
                    {props?.data?.length > 0 ? props?.data?.map((val: any) => {
                        return ( 
                            <tr className='text-left' key={Math.random()}>
                                <td className={val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""}>{val?.pts_maintenance}</td>
                                <td className={val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""}>{val?.pts_scope}</td>
                                <td className={val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""}>{val?.pts_desc}</td>
                                <td className={val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""}>{val?.pts_start_date}</td>
                            </tr>
                            
                        )
                    }) : <tr><td colSpan={7}><Empty description={props.TranslateString("Empty")} /></td></tr>}
                </tbody>
            </table>
        </>
    );
}

export default PDFPage9Table2;